<script>
    import { Pie } from "svelte-chartjs";

    import { Chart, ArcElement, Title, Tooltip, Legend } from "chart.js";

    Chart.register(Title, Tooltip, Legend, ArcElement);

    export let title = "",
        width = "",
        height = "",
        isResponsive = false,
        borderWidth = Number(0),
        labels = [],
        chartData = [],
        backgroundColorArr = [],
        borderColorArr = [];

    const data = {
        labels: labels.length ? labels : [],
        datasets: [
            {
                label: title ? title : "No title specified",
                data: chartData.length ? chartData : [],
                backgroundColor: backgroundColorArr.length
                    ? backgroundColorArr
                    : [
                          "rgba(255, 134,159, 0.4)",
                          "rgba(98,  182, 239, 0.4)",
                          "rgba(255, 218, 128, 0.4)",
                          "rgba(113, 205, 205, 0.4)",
                          "rgba(170, 128, 252, 0.4)",
                          "rgba(255, 177, 101, 0.4)",
                      ],
                borderWidth: borderWidth ? borderWidth : 2,
                borderColor: borderColorArr.length
                    ? borderColorArr
                    : [
                          "rgba(255, 134, 159, 1)",
                          "rgba(98,  182, 239, 1)",
                          "rgba(255, 218, 128, 1)",
                          "rgba(113, 205, 205, 1)",
                          "rgba(170, 128, 252, 1)",
                          "rgba(255, 177, 101, 1)",
                      ],
            },
        ],
    };

    const getOptions = (isResponsive) => {
        const options = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            let label = context.label || "";

                            if (context.parsed)
                                return `${label}: ${context.parsed}%`;
                            else return "";
                        },
                    },
                },
            },
        };

        return isResponsive
            ? { responsive: true, ...options }
            : { maintainAspectRatio: false, ...options };
    };

    const getClass = (width, height) => {
        return `w-[${width}] h-[${height}]`;
    };
</script>

<div class={getClass(width, height)}>
    {#if chartData.length == 0 || labels.length == 0}
        <div class="flex-1 items-center text-center">No data</div>
    {:else}
        <Pie {data} options={getOptions(isResponsive)} />
    {/if}
</div>
